import axios from 'axios';
import useSWR from 'swr';

import { useLocale } from '@/hooks/locale/useLocale';
import { BlogCategory, BlogPost } from '@/utils/blogPosts';
import { calmLogger } from '@/utils/calmLogger';
import getUrl from '@/utils/getUrl';

const fetcher = async (endpoint: string): Promise<BlogPost[]> => {
	try {
		const { data } = await axios.get<{ items: BlogPost[] }>(endpoint);
		return data?.items ?? [];
	} catch (error) {
		calmLogger.warn('Failed to fetch blog posts', {
			endpoint,
			error: error instanceof Error ? error.message : String(error),
			stack: error instanceof Error ? error.stack : undefined,
		});
		return [];
	}
};

export const useBlogPosts = (category: BlogCategory) => {
	const { calmLanguage } = useLocale();

	const endpoint = `${getUrl('web-api')}/blog-posts?category=${category}`;

	const { data, isValidating, error } = useSWR<BlogPost[]>(calmLanguage === 'en' ? endpoint : null, fetcher, {
		revalidateOnFocus: false,
		errorRetryCount: 0,
	});

	return {
		blogPosts: data ?? [],
		isLoading: !data && isValidating,
		error,
	};
};
